const baseUrl = 'https://tsdev.gdxsports.com/api/v1'
export default baseUrl
